import { useState } from 'react';
import styled from '@emotion/styled'

import { BasicFlex } from '../../../utils/Common';

import { Card, CardContent, Avatar, IconButton } from '@mui/material';

import { formatGenericDate, formatGenericTime, formatCurrency } from '../../../utils/util';

import { CardBlock, CardBlockContainer } from '../../../utils/utilities/CardComponents';

// reusable components
import AppointmentStatus from '../../Appointments/Components/AppointmentStatus';
import ModifyAppointment from '../../Appointments/Components/ModifyAppointment';

// mui icons
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import Person3RoundedIcon from '@mui/icons-material/Person3Rounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';
import SimpleChip from '../../../utils/utilities/SimpleChip';

import { CheckoutContext } from '../../../contexts/Checkout';

import Dialog from '../../../utils/utilities/Dialog';

import EditCheckout from '../../Checkout/EditCheckout';

const TopBlock = styled(BasicFlex)`
  /* background-color: ${props => props.theme.colors.lightBg}; */
  padding: 1rem 1.6rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

const TitleBlock = styled(BasicFlex)`
  gap: 1rem;
`;

const CustomerInfo = styled(BasicFlex)`
  gap: .3rem;

  .title {
    font-weight: 600;
    font-size: 1.6rem;
  }
`;

const StatusChip = styled.div`
  width: fit-content;
  /* margin-top: .2rem;
  margin-bottom: 1.5rem; */
`;

const ActionButtons = styled.div`
  max-width: 45rem;
`

const AppointmentCard = ({ event = {}}) => {

  const [appointment, setAppointment] = useState(null);

  const [expand, setExpand] = useState(true);

  const toggleExpand = () => setExpand(!expand);

  console.log(event, "event");

  const basicBlock = [
    {header: "", icon: <TodayRoundedIcon fontSize="small" />, info: `${formatGenericTime(event.start_time)} - ${formatGenericTime(event.end_time)}`, spread: "2rem"},
    {header: "", icon: <Person3RoundedIcon fontSize="small" />, info: <SimpleChip label={event.stylist} />, spread: "2rem"},
    {header: "", icon: <AccessTimeRoundedIcon fontSize="small" />, info: `${event.duration_in_minutes} minutes`, spread: "2rem"},
    {header: "", icon: <PaidRoundedIcon fontSize="small" />, info: formatCurrency(event.subtotal), spread: "2rem"}
  ]

  return (
    <CheckoutContext.Provider value={{ appointment, setAppointment }}>
    <Card variant="outlined">
      <TopBlock justify="space-between">
        <TitleBlock width="30rem">
          <Avatar variant='rounded' sx={{ bgcolor: 'secondary.soft'}} ><EventRoundedIcon /></Avatar>
          <CustomerInfo dir="column">
            <div className="title">{event.title}</div>
            <div>{formatGenericDate(event.appointment_date)}</div>
          </CustomerInfo>
        </TitleBlock>

        <AppointmentStatus event={event} displayText raised={false}  />
        
      </TopBlock>
      {/* <Divider /> */}
      <CardContent sx={{pt: 0}}>
        <BasicFlex justify="flex-end" align="center" my=".5rem">
          {/* <StatusChip>
            <MultiStatusChip value={event.status} values={[{value: "scheduled", label: "Scheduled", status: "primary"}, {value: "in_progress", label: "In Progress", status: "warning"}, {value: "completed", label: "Show", status: "success"}, {value: "no_show", status: "error"}, {value: "cancelled", label: "Cancelled", status: "error"}]} />
          </StatusChip> */}
          <IconButton onClick={toggleExpand} size="small"><MoreHorizRoundedIcon /></IconButton>
        </BasicFlex>
        
        {expand && (
          <CardBlockContainer>
            {/* <CardBlockHeader>Details</CardBlockHeader> */}
            {basicBlock.map((block, i) => <CardBlock key={i} {...block} />)}
          </CardBlockContainer>
        )}
      </CardContent>
      <BasicFlex justify="flex-end">
        <ActionButtons>
          <ModifyAppointment event={event} />
        </ActionButtons>
      </BasicFlex>
    </Card>

    <Dialog 
      fullScreen 
      forceOpen={appointment?.appointment_id ? true : false} 
      title="Appointment Checkout" 
      useForm={true} 
      forceClose={() => setAppointment(null)}
    >
      <EditCheckout />
    </Dialog>
    </CheckoutContext.Provider>
  )

};

export default AppointmentCard;